import React, { useEffect, useState } from "react"
import "./SeoDataTable.scss"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { Card, CardBody, Button, Table, Spinner, Pagination, PaginationItem, PaginationLink, Row, Col } from "reactstrap"
import seoApi from "Api/seoApi"
import { useNavigate } from "react-router-dom"
import DataTableLoader from "SkeletonLoader/DataTableLoader"

const SeoDataTable = () => {
  document.title = "SEO"
  const navigate = useNavigate()
  const accessToken = localStorage.getItem("accessToken")
  const [seoDetails, setSeoDetails] = useState([])
  const [page, setPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [limit, setLimit] = useState(10)
  const [loading, setLoading] = useState(true)

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "SEO", link: "#" },
  ]

  const getAllSeoDetails = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        limit: limit,
        page: page,
      },
    }

    seoApi
      .getSeo(config)
      .then(response => {
        if (response.data.success) {
          setLoading(false)
          setSeoDetails(response.data.data)
          setTotalRecords(response.data.totalSeo)
        }
      })
      .catch(error => {
        console.log("Error Fetching SEO", error)
      })
  }

  useEffect(() => {
    getAllSeoDetails()
  }, [accessToken, page, limit])

  const totalPages = Math.ceil(totalRecords / limit)

  const handleAddSeoClick = () => {
    navigate("/add-seo")
  }

  return (
    <>
      <Row>
        <Col xs="12">
          <div className="seo-list-header d-flex align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="SEO" />
            <div className="d-flex align-items-center gap-3">
              <Button
                type="button"
                color="secondary"
                className="waves-effect"
                onClick={handleAddSeoClick}
              >
                Add SEO
              </Button>
            </div>
          </div>

          <div className="seo-data-table table-responsive mt-4 mb-3">
            {loading ? (
              <DataTableLoader cols={6} />
            ) : (
              <Table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Page Name</th>
                    <th>Title</th>
                    <th>Description</th>
                    <th>Keywords</th>
                    <th>Edit</th>
                    <th>View</th>
                    
                  </tr>
                </thead>
                <tbody>
                  {seoDetails.map((seo, index) => (
                    <tr key={seo._id} className="seo-table-row">
                      <th scope="row">{(page - 1) * limit + index + 1}</th>
                      <td>{seo.pageName}</td>
                      <td>{seo.title}</td>
                      <td>{seo.description}</td>
                      <td>{seo.keywords}</td>
                      <td>
                          <span
                            className="edit-seo"
                            onClick={() => {
                              navigate(
                                `/edit-seo/${seo?._id}`,
                                { state: seo },
                              );
                            }}
                          >
                            <i className="ion ion-md-create" />
                          </span>
                        </td>
                     

                      <td>
                        <span
                          onClick={() => {
                            navigate(
                                `/view-seo/${seo?._id}`,
                            );
                          }}
                          className="view-seo"
                        >
                          <i className="ion ion-md-eye" />
                        </span>
                      </td>     
                     
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>
          <div className="pagination-container d-flex align-items-center justify-content-end">
            <Pagination>
              <PaginationItem disabled={page <= 1}>
                <PaginationLink previous onClick={() => setPage(page - 1)} />
              </PaginationItem>
              {[...Array(Math.min(3, totalPages))].map((_, index) => (
                <PaginationItem key={index} active={index + 1 === page}>
                  <PaginationLink onClick={() => setPage(index + 1)}>
                    {index + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}

              {totalPages > 6 && page > 3 && page < totalPages - 2 && (
                <PaginationItem disabled>
                  <PaginationLink>...</PaginationLink>
                </PaginationItem>
              )}

              {totalPages > 6 && page > 3 && page < totalPages - 2 && (
                <PaginationItem active>
                  <PaginationLink onClick={() => setPage(page)}>
                    {page}
                  </PaginationLink>
                </PaginationItem>
              )}

              {totalPages > 6 && page < totalPages - 2 && (
                <PaginationItem disabled>
                  <PaginationLink>...</PaginationLink>
                </PaginationItem>
              )}

              {totalPages > 3 &&
                [...Array(Math.min(3, totalPages))].map((_, index) => {
                  const pageNumber = totalPages - 2 + index;
                  return (
                    <PaginationItem key={pageNumber} active={pageNumber === page}>
                      <PaginationLink onClick={() => setPage(pageNumber)}>
                        {pageNumber}
                      </PaginationLink>
                    </PaginationItem>
                  );
                })}
              <PaginationItem disabled={page >= totalPages}>
                <PaginationLink next onClick={() => setPage(page + 1)} />
              </PaginationItem>
            </Pagination>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default SeoDataTable
